import {
	Button,
	CircularProgress,
	IconButton,
	Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { SpinnerWrapper } from './useSpinner';
import { useRef } from 'react';
import PropTypes from 'prop-types';

ButtonWrapper.propTypes = {
	label: PropTypes.string,
	id: PropTypes.any,
	disabled: PropTypes.bool,
	classList: PropTypes.string,
	variant: PropTypes.any,
	icon: PropTypes.element,
	endIcon: PropTypes.element,
	type: PropTypes.string,
	loading: PropTypes.bool,
	loaderSpinnerClass: PropTypes.string,
	iconButton: PropTypes.bool,
	hideBtn: PropTypes.bool,
	linkTo: PropTypes.any,
	target: PropTypes.string,
	uploadButton: PropTypes.bool,
	fileUploadTypes: PropTypes.string,
	tooltip: PropTypes.any,
	isErrorButton: PropTypes.bool,
	size: PropTypes.string,
	onClick: PropTypes.func,
	onFileUpload: PropTypes.func,
	form: PropTypes.string,
};

export default function ButtonWrapper({
	label,
	id,
	disabled,
	classList,
	variant,
	icon,
	endIcon,
	type = 'button',
	loading,
	loaderSpinnerClass,
	iconButton,
	hideBtn,
	linkTo,
	target = '_blank',
	uploadButton,
	fileUploadTypes = '.jpg, .jpeg, .pdf, .svg, .png',
	tooltip,
	isErrorButton,
	size = 'medium',
	spinnerSize = 20,
	onClick,
	onFileUpload,
	textColor = null,
	enableTextWrap = false,
	form,
}) {
	const fileInput = useRef();

	if (variant !== 'outlined' && !iconButton) {
		classList = classList + ` ${textColor ? textColor : '!text-white'}`;
	}

	if (variant === 'error') {
		classList = classList + ` !bg-red-600`;
	}

	if (variant === 'neutral') {
		classList = classList + ` !secondary-btn`;
	}

	const uploadFile = (event) => {
		onFileUpload && onFileUpload(event.target.files[0]);
		fileInput.current.value = null;
	};

	const getButton = () => {
		return (
			<>
				<Button
					sx={{ height: 'fit-content' }}
					title={tooltip}
					key={id}
					LinkComponent={linkTo ? 'a' : 'button'}
					href={linkTo}
					target={target}
					disabled={disabled || loading}
					className={`${classList} ${isErrorButton ? '!bg-red-500 !text-white' : ''
						} ${!label ? 'no-button-label' : ''}`}
					startIcon={icon}
					onClick={(e) => {
						onClick && onClick(e);
						if (uploadButton) {
							fileInput.current.click();
						}
					}}
					type={type}
					form={form}
					variant={variant ? variant : 'contained'}
					endIcon={endIcon}>
					<Box sx={{ display: 'flex', alignItems: 'center', maxWidth: enableTextWrap || linkTo ? '96%' : '100%' }}>
						{loading ? (
							<Box sx={{ display: 'flex', alignItems: 'center' }}>
								<Box>Loading</Box>
								<SpinnerWrapper
									classList={`mx-2 ${loaderSpinnerClass ? loaderSpinnerClass : '!text-white'
										}`}></SpinnerWrapper>
							</Box>
						) : (
							<>
								{label ? (
									<Typography
										variant="subtitle2"
										sx={{
											lineHeight: '24px',
											textTransform: 'none',
											whiteSpace: enableTextWrap || linkTo ? 'nowrap' : 'normal',
											textOverflow: enableTextWrap || linkTo ? 'ellipsis' : 'unset',
											width: "100%",
											overflow: enableTextWrap || linkTo ? "hidden" : 'auto'
										}}>
										{label}
									</Typography>
								) : null}
							</>
						)}
					</Box>
				</Button>
				<input
					onChange={uploadFile}
					ref={fileInput}
					accept={fileUploadTypes}
					type="file"
					style={{ display: 'none' }}
				/>
			</>
		);
	};

	return (
		<>
			{hideBtn ? null : (
				<>
					{!iconButton ? (
						getButton()
					) : (
						<IconButton
							size={size}
							title={tooltip}
							disabled={disabled}
							className={`!icon-bg-color ${classList} !relative`}
							onClick={(e) => {
								onClick && onClick(e);
							}}>
							{loading ? <CircularProgress size={spinnerSize} /> : icon}
						</IconButton>
					)}
				</>
			)}
		</>
	);
}
